import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import './index.css';
import App from './App';
import { msalConfig } from './authConfig';

const msalInstance = new PublicClientApplication(msalConfig);

// Postavi aktivni nalog nakon uspesnog logina i pri startu (ako vec postoji).
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
    msalInstance.setActiveAccount(event.payload.account);
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));

// msalInstance.initialize() je obavezan pre rendera u msal-browser v3.
msalInstance.initialize()
  // Povratak sa redirect prijave (kad je popup bio blokiran): ID token čeka na /login
  // da ga LoginPage razmeni za Basecamp sesiju.
  .then(() => msalInstance.handleRedirectPromise().catch(() => null))
  .then((result) => {
    if (result?.idToken) sessionStorage.setItem('basecamp_ms_redirect_idtoken', result.idToken);
    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>
    );
  });
